import React, { useState } from "react";
import { Card, Accordion, Form, InputGroup } from "react-bootstrap";

const TroubleshootingGuide = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const troubleshootingItems = [
    {
      issue: "Dense or gummy crumb",
      causes: [
        "Underfermented dough",
        "Insufficient gluten development",
        "Too much moisture",
      ],
      solutions: [
        "Extend bulk fermentation time",
        "Increase number of stretch and folds",
        "Reduce hydration level by 5-10%",
      ],
    },
    {
      issue: "Flat loaf with no oven spring",
      causes: [
        "Overfermented dough",
        "Weak starter",
        "Insufficient surface tension",
      ],
      solutions: [
        "Reduce fermentation time or temperature",
        "Feed starter more frequently",
        "Improve shaping technique for better tension",
      ],
    },
    {
      issue: "Too sour taste",
      causes: [
        "Long cold fermentation",
        "Mature/old starter",
        "High whole grain percentage",
      ],
      solutions: [
        "Reduce cold proof time",
        "Feed starter more frequently",
        "Reduce whole grain percentage",
      ],
    },
    {
      issue: "Burnt bottom crust",
      causes: [
        "Oven temperature too high",
        "Baking stone/steel too hot",
        "Insufficient insulation",
      ],
      solutions: [
        "Reduce oven temperature by 25°F",
        "Add a baking sheet on lower rack",
        "Double up baking sheets",
      ],
    },
    {
      issue: "Starter not rising",
      causes: ["Too cold environment", "Old flour", "Incorrect feeding ratio"],
      solutions: [
        "Find warmer spot (75-85°F)",
        "Use fresh, quality flour",
        "Maintain 1:1:1 ratio (starter:flour:water)",
      ],
    },
  ];

  const filteredItems = troubleshootingItems.filter(
    (item) =>
      item.issue.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.causes.some((cause) =>
        cause.toLowerCase().includes(searchTerm.toLowerCase())
      ) ||
      item.solutions.some((solution) =>
        solution.toLowerCase().includes(searchTerm.toLowerCase())
      )
  );

  return (
    <Card className="mb-4">
      <Card.Header>
        <h4>Troubleshooting Guide</h4>
        <InputGroup className="mt-3">
          <Form.Control
            placeholder="Search issues, causes, or solutions..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Card.Header>
      <Card.Body>
        <Accordion>
          {filteredItems.map((item, index) => (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header>{item.issue}</Accordion.Header>
              <Accordion.Body>
                <h6>Possible Causes:</h6>
                <ul>
                  {item.causes.map((cause, i) => (
                    <li key={i}>{cause}</li>
                  ))}
                </ul>
                <h6>Solutions:</h6>
                <ul>
                  {item.solutions.map((solution, i) => (
                    <li key={i}>{solution}</li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Card.Body>
    </Card>
  );
};

export default TroubleshootingGuide;
